var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDismiss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.665512 0.795149L0.726027 0.72505C0.947916 0.503162 1.29514 0.48299 1.53981 0.664535L1.60991 0.72505L7.0013 6.11616L12.3927 0.72505C12.6368 0.480973 13.0325 0.480973 13.2766 0.72505C13.5207 0.969128 13.5207 1.36486 13.2766 1.60893L7.88547 7.00033L13.2766 12.3917C13.4985 12.6136 13.5186 12.9608 13.3371 13.2055L13.2766 13.2756C13.0547 13.4975 12.7075 13.5177 12.4628 13.3361L12.3927 13.2756L7.0013 7.88449L1.60991 13.2756C1.36583 13.5197 0.970105 13.5197 0.726027 13.2756C0.481949 13.0315 0.481949 12.6358 0.726027 12.3917L6.11714 7.00033L0.726027 1.60893C0.504138 1.38705 0.483967 1.03983 0.665512 0.795149L0.726027 0.72505L0.665512 0.795149Z",
    fill: "#0F111C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDismiss);
export default __webpack_public_path__ + "static/media/dismiss.ae7fc774d8843e0d76e96c202dc1da84.svg";
export { ForwardRef as ReactComponent };